"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Scan = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Scan_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5A2.5 2.5 0 0 1 2.5 0H5a.5.5 0 0 1 0 1H2.5A1.5 1.5 0 0 0 1 2.5V5a.5.5 0 0 1-1 0V2.5ZM2.5 16A2.5 2.5 0 0 1 0 13.5V11a.5.5 0 0 1 1 0v2.5A1.5 1.5 0 0 0 2.5 15H5a.5.5 0 0 1 0 1H2.5ZM13.5 0A2.5 2.5 0 0 1 16 2.5V5a.5.5 0 0 1-1 0V2.5A1.5 1.5 0 0 0 13.5 1H11a.5.5 0 0 1 0-1h2.5ZM16 13.5a2.5 2.5 0 0 1-2.5 2.5H11a.5.5 0 0 1 0-1h2.5a1.5 1.5 0 0 0 1.5-1.5V11a.5.5 0 0 1 1 0v2.5ZM0 8a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 8ZM11 4H5a1 1 0 0 0-1 1v1a.5.5 0 0 1-1 0V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1a.5.5 0 0 1-1 0V5a1 1 0 0 0-1-1ZM3.5 9.5a.5.5 0 0 1 .5.5v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a.5.5 0 0 1 1 0v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a.5.5 0 0 1 .5-.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Scan_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Scan;
exports["default"] = _default;